import { Component, OnInit, Inject,Input } from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { NaoEncontrei } from '../../../../models/naoEncontrei.model';
import { AngularFirestore } from "angularfire2/firestore";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
    selector: 'mensagem-dialog',
    templateUrl: './mensagem.html',
    styleUrls: []
})
export class MensagemDialog implements OnInit {
    item:any;//={fornecedor:0, nome:""};
    @Input()
    title:string = "Enviar uma mensagem para a plataforma";
    constructor(
        private db: AngularFirestore,
        private dialogRef: MatDialogRef<MensagemDialog>,
        @Inject(MAT_DIALOG_DATA) data) {
        if (data.data)    
          this.item = data;
        if (data.title)
          this.title = data.title;   
    }

    ngOnInit() {
    }

    ok() {
       if (this.item.nome>""){ 
        let d = new NaoEncontrei(this.db,this.item.fornecedor);
        d.add(this.item);
        this.dialogRef.close(this.item);
       }
    }

    cancelar() {
        this.dialogRef.close();
    }
}